import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';
import { ErrorMarkup } from 'modules/error';
import { PageHeader } from '../PageHeader';
import { SmsModals } from './SmsModals';
import { Sidebar } from '../Sidebar';
import { SmsAccountsSection } from './SmsAccountsSection';
import { Wrapper, MainContent } from '../Page.styled';
import { useSendingPlatformsQueryContext } from '../../../contexts';
import { SendingPlatform, ITERABLE_SMS } from '../../../constants';
import { SmsAccountsHeader } from './SmsAccountsHeader';

export const SmsPage = ({ sendingPlatform }: { sendingPlatform: SendingPlatform }) => {
  const { hasError, isLoadingEssentialData } = useSendingPlatformsQueryContext();

  const { SendingPlatformsIterableSMSUI } = useSelector(selectFeatureFlags);
  const isRestricted = sendingPlatform === ITERABLE_SMS && !SendingPlatformsIterableSMSUI;

  if (hasError || isRestricted)
    return (
      <ErrorMarkup
        id="sending-platforms-details-error-page"
        fallbackLinkTo="/settings/sendingPlatforms"
        fallbackLinkToText="Back to Sending Platforms"
      />
    );

  return (
    <>
      <div>
        <PageHeader sendingPlatform={sendingPlatform} />
        <Wrapper>
          <Sidebar sendingPlatform={sendingPlatform} />
          <MainContent>
            <SmsAccountsHeader sendingPlatform={sendingPlatform} />
            <SmsAccountsSection sendingPlatform={sendingPlatform} />
          </MainContent>
        </Wrapper>
      </div>
      {!isLoadingEssentialData && <SmsModals />}
    </>
  );
};
